/* eslint-disable */
import React from 'react'
import { Spacer, Field, Button } from '@cleartrip/bento'

import OfflineToast from '../offlineToast'
import ModalHeader from '../UserProfileModalHeader'

import USER_PROFILE_PAGE_CONTANTS from '../UserProfileConstants'

const ResetPassword = ({
  toggle,
  validateEmailHandler,
  changeEmailHandler,
  isEmailValid,
  email,
  resetPassword,
  validateEmail
}) => {
  return (
    <div
      className="bg-white br-4 br-4 o-hidden d-flex flex-column"
      style={{
        width: '400px',
        height: '468px'
      }}
    >
      <div
        className="px-8 d-flex flex-1 flex-column"
        onKeyDown={e => {
          if (e.key === 'Enter') {
            resetPassword(
              USER_PROFILE_PAGE_CONTANTS.RESET_CONFIRMATION_PAGE,
              true,
              email
            )
          }
        }}
      >
        <ModalHeader title="Reset your password" toggle={toggle} />
        <Spacer className="mb-1" />
        <div className="flex flex-1 flex-column">
          <OfflineToast page="reset password" />
          <div className="flex flex-1 flex-column">
            <div className="d-flex flex-column">
              <div className="c-neutral-700 fs-3 mb-3">
                Confirm the email address you used to register or book on
                Cleartrip
              </div>
              <Field
                type="email"
                placeholder="Enter email address"
                className=" lh-title"
                onBlur={validateEmailHandler}
                onChange={changeEmailHandler}
                hasError={!isEmailValid}
                value={email}
                data-testid="email"
              />

              {!isEmailValid &&
                (email === '' ? (
                  <div
                    data-testid="invalidEmailReset"
                    className="c-error-500 fs-2 mt-1"
                  >
                    {'Please enter an email address.'}
                  </div>
                ) : validateEmail(email) ? (
                  <div className="c-error-500 fs-2 mt-1">
                    {'Email address is not registered with Cleartrip.'}
                  </div>
                ) : (
                  <div className="c-error-500 fs-2 mt-1">
                    Please enter a valid email address.
                  </div>
                ))}
            </div>
          </div>
          <div className="flex flex-column mb-8">
            <Button
              size="md"
              type="secondary"
              full={true}
              onClick={() =>
                resetPassword(
                  USER_PROFILE_PAGE_CONTANTS.RESET_CONFIRMATION_PAGE,
                  true,
                  email
                )
              }
            >
              <span className="fs-3 fw-550">Get password reset link</span>
            </Button>
          </div>
        </div>
      </div>
    </div>
  )
}

export default ResetPassword
